import React from 'react'
import { Form } from 'antd'
import { RichTextEditor } from 'packages/components/RichText'

export const EditStem: React.FC<{
  disabled?: boolean
}> = ({ disabled }) => {
  return (
    <Form.Item
      label={'题干'}
      name="stem"
      rules={[{ required: true, message: '请输入题干' }]}
    >
      <RichTextEditor
        minHeight={64}
        readOnly={!!disabled}
        excludeKeys={[
          'headerSelect',
          'group-upload',
          'insertLink',
          'fullScreen',
        ]}
        insertKeys={{
          index: 17,
          keys: ['uploadImage', 'insertFormula'],
        }}
      />
    </Form.Item>
  )
}
